import { render, staticRenderFns } from "./broj-dokumenta.editor.vue?vue&type=template&id=29687549&scoped=true&"
import script from "./broj-dokumenta.editor.vue?vue&type=script&lang=ts&"
export * from "./broj-dokumenta.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29687549",
  null
  
)

export default component.exports